(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-header"] && !Shopify.designMode) return;
  try {
    
  // Header behaviour that markup alone cannot express. All listeners are on
  // document, so they survive the section being re-rendered by the theme
  // editor and need no re-binding.
  (() => {
    const DROPDOWN = '.tll-header__dropdown';
    const DRAWER = '.tll-header__drawer';

    const close = (element) => {
      if (element) element.open = false;
    };

    // `toggle` does not bubble, but it still travels the capture path.
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement)) return;

        const summary = details.querySelector(':scope > summary');
        if (summary?.hasAttribute('aria-expanded')) {
          summary.setAttribute('aria-expanded', String(details.open));
        }

        // One dropdown open at a time, as on teleleo.com.
        if (details.open && details.matches(DROPDOWN)) {
          document.querySelectorAll(`${DROPDOWN}[open]`).forEach((other) => {
            if (other !== details) close(other);
          });
        }
      },
      true
    );

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      // Backdrop, close button, or any link inside the drawer.
      if (target.closest('[data-tll-drawer-close]') || target.closest(`${DRAWER} a`)) {
        close(target.closest(DRAWER));
      }

      document.querySelectorAll(`${DROPDOWN}[open]`).forEach((dropdown) => {
        if (!dropdown.contains(target)) close(dropdown);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(`${DROPDOWN}[open], ${DRAWER}[open]`).forEach(close);
    });

    // Publishes the header's own height as --tll-header-h.
    //
    // A sticky header stays in flow, so it pushes the first section down by its full
    // height. teleleo.com's header is `fixed`, so its hero starts at y=0 and fills exactly
    // one screen. Without this variable ours starts one header lower and every section on
    // the page inherits the offset. `.tll-hero--full` reads it and pulls itself back up.
    //
    // Horizon's own --header-height is the header row only (60px) and excludes the
    // announcement bar above it, so it cannot be used here.
    const publishHeight = () => {
      const header = document.querySelector('.tll-header');
      if (!header) return;
      const group = header.closest('.shopify-section') ?? header;
      document.documentElement.style.setProperty(
        '--tll-header-h',
        `${Math.round(group.getBoundingClientRect().height)}px`
      );
    };

    publishHeight();
    if (typeof ResizeObserver === 'function') {
      const header = document.querySelector('.tll-header');
      const group = header?.closest('.shopify-section');
      if (group) new ResizeObserver(publishHeight).observe(group);
    }
    window.addEventListener('resize', publishHeight);
    document.addEventListener('shopify:section:load', publishHeight);
  })();

  } catch(e) { console.error(e); }
})();
})();
